import common from './common'
import res from '@/i18n/en/res'
import intro from '@/i18n/en/intro'
const en = {
  ...common,
  reservation: res,
  introduction: intro,
}
export default en
